import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography, Stack } from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

//components
import RippleEffect from '../../../components/RippleEffect/RippleEffect'
import StyledTable from '../../../components/ReactTable/StyledTable'
import StyledTableContainer from '../../../components/StyledTableContainer/StyledTableContainer'

import { getDisplayName } from '../../../utils/common.utils'
import { useDashboardGlobalStateContext } from '../../../context/DashboardGlobalStateContext'

const LiveDataTabular = ({ machineData }) => {
  const navigate = useNavigate()

  const openMachinePage = (rowValues) => {
    navigate(
      `/spd/dashboard/machine-wise?tab=overview&machine=${rowValues.machine}`
    )
  }

  const { machines: machineOptions } = useDashboardGlobalStateContext()

  const machineColumns = [
    {
      Header: 'S.No',
      accessor: 'index'
    },
    {
      Header: 'Status',
      accessor: 'machineStatus',
      Cell: ({ cell: { row } }) => {
        return (
          <RippleEffect
            machineStatus={
              row.values.machineStatus === true ||
              row.values.machineStatus === 1
                ? false
                : true
            }
          />
        )
      }
    },
    {
      Header: 'Machine',
      accessor: 'machine',
      Cell: ({ cell: { row } }) => {
        const displayName = getDisplayName(row.values.machine, machineOptions)
        return (
          <Stack
            sx={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              cursor: 'pointer',
              '& svg': { fontSize: '14px' }
            }}
            onClick={() => {
              openMachinePage(row.values)
            }}
          >
            <Typography>{displayName}</Typography>
            <OpenInNewIcon />
          </Stack>
        )
      }
    },
    {
      Header: 'Operator',
      accessor: 'operator'
    },
    {
      Header: 'Part number',
      accessor: 'name'
    },
    {
      Header: 'Operation',
      accessor: 'type'
    },
    {
      Header: 'Part count',
      accessor: 'partCount'
    },
    {
      Header: 'Production ID',
      accessor: 'productionId'
    },
    {
      Header: 'Rejection count',
      accessor: 'rejectionCount'
    },
    {
      Header: 'Idletime',
      accessor: 'idleTime'
    }
  ]

  return (
    <StyledTableContainer>
      <StyledTable
        pagination={false}
        //rowClickHandler={openMachinePage}
        columns={machineColumns}
        data={machineData}
        hiddenColumns={[]}
      />
    </StyledTableContainer>
  )
}

export default LiveDataTabular
